import { Injectable, OnDestroy } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  BatchSdk,
  DocumentAnalysisSdk,
  DocumentManagementSdk,
  DocTypeMappingSdk,
  UsersSdk,
  TranscriptMetaDataSdk,
  ConnectorSdk,
  EtriveConnectSdk,
  ITPIntegrationSourceSdk,
  ITPIntegrationStepSdk,
  ITPIntegrationCredentialSdk
} from '@softdocs/capture-ui-libraries';

@Injectable({
  providedIn: 'root'
})
export class AutoclassifierSdkService {
  private _batchSdk: BatchSdk;
  private _documentAnalysisSdk: DocumentAnalysisSdk;
  private _documentManagementSdk: DocumentManagementSdk;
  private _docTypeMappingSdk: DocTypeMappingSdk;
  private _usersSdk: UsersSdk;
  private _transcriptMetaDataSdk: TranscriptMetaDataSdk;
  private _connectorSdk: ConnectorSdk;
  private _etriveConnectSdk: EtriveConnectSdk;
  private _iTPIntegrationSourceSdk: ITPIntegrationSourceSdk;
  private _iTPIntegrationStepSdk: ITPIntegrationStepSdk;
  private _iTPIntegrationCredentialSdk: ITPIntegrationCredentialSdk;
  constructor() {
    // Instantiate all SDKs once with baseURL from environment
    this._batchSdk = new BatchSdk(environment.urls.autoclassifierApi);

    this._documentAnalysisSdk = new DocumentAnalysisSdk(environment.urls.transcriptApi);

    this._documentManagementSdk = new DocumentManagementSdk(environment.urls.autoclassifierApi);

    this._docTypeMappingSdk = new DocTypeMappingSdk(environment.urls.autoclassifierApi);

    this._usersSdk = new UsersSdk(environment.urls.autoclassifierApi);

    this._transcriptMetaDataSdk = new TranscriptMetaDataSdk(environment.urls.transcriptApi);

    this._connectorSdk = new ConnectorSdk(environment.urls.transcriptApi);

    this._etriveConnectSdk = new EtriveConnectSdk(environment.urls.autoclassifierApi);

    this._iTPIntegrationSourceSdk = new ITPIntegrationSourceSdk(environment.urls.autoclassifierApi);

    this._iTPIntegrationStepSdk = new ITPIntegrationStepSdk(environment.urls.autoclassifierApi);

    this._iTPIntegrationCredentialSdk = new ITPIntegrationCredentialSdk(
      environment.urls.autoclassifierApi
    );
  }

  // Expose getters for each SDK
  /**
   *
   */
  get batchSdk(): BatchSdk {
    return this._batchSdk;
  }

  /**
   *
   */
  get documentAnalysisSdk(): DocumentAnalysisSdk {
    return this._documentAnalysisSdk;
  }

  /**
   *
   */
  get documentManagementSdk(): DocumentManagementSdk {
    return this._documentManagementSdk;
  }

  /**
   *
   */
  get docTypeMappingSdk(): DocTypeMappingSdk {
    return this._docTypeMappingSdk;
  }

  /**
   *
   */
  get usersSdk(): UsersSdk {
    return this._usersSdk;
  }

  /**
   *
   */
  get transcriptMetaDataSdk(): TranscriptMetaDataSdk {
    return this._transcriptMetaDataSdk;
  }

  /**
   *
   */
  get connectorSdk(): ConnectorSdk {
    return this._connectorSdk;
  }

  /**
   *
   */
  get etriveConnectSdk(): EtriveConnectSdk {
    return this._etriveConnectSdk;
  }

  /**
   *
   */
  get itpIntegrationSourceService(): ITPIntegrationSourceSdk {
    return this._iTPIntegrationSourceSdk;
  }

  /**
   *
   */
  get integrationStepService(): ITPIntegrationStepSdk {
    return this._iTPIntegrationStepSdk;
  }

  /**
   *
   */
  get itpIntegrationCredentialService(): ITPIntegrationCredentialSdk {
    return this._iTPIntegrationCredentialSdk;
  }
}
